import axios from 'axios';

export function getCreateTeam(projectUserId) {
  return axios.get(`project/${projectUserId}/team`);
}

export function addMember(projectUserId, payload) {
  return axios.post(`project/${projectUserId}/team/add`, payload);
}

export function addSpecialist(payload) {
  return axios.post('/add-specialist', payload);
}

export function getAddSpecialist(projectUserId, areaSelected) {
  return axios.get(`/add-specialist/${projectUserId}`, {
    params: {
      area: areaSelected
    }
  })
}

export function removeMember(projectUserId, payload) {
  return axios.post(`project/${projectUserId}/team/remove`, payload);
}

export function confirmTeam(projectUserId) {
  return axios.post(`project/${projectUserId}/team/confirm`);
}

export function invite(projectId, userId) {
  return axios.post('/invite', {
    project_id: projectId,
    user_id: userId,
  })
}

export function searchSpecialist(config) {
  return axios.get(`/search/specialist`, config);
}